import env from '@travel/env';
import { stringifyQueryParameter } from '@travel/traveler-core/utils/jrdpHelper';

import type { URLSearchQuery } from 'Common-Types';

export const basePaths = {
  providerList: '/hotel_list',
  providerListMap: '/hotel_list_map',
  plansList: '/hotel_info_plan',
  planDetail: '/hotel_info_plan_detail',
  trainSearch: '/train_select',
  itinerary: '/itinerary',
  notFound: '/not_found',
};

const HOTEL_TOP_LINK = 'https://hotel.travel.rakuten.co.jp';
const HOTEL_TOP_REVIEW_LINK = 'https://review.travel.rakuten.co.jp/hotel/voice';
const RAKUTEN_TRAVEL_TOP_LINK = 'https://travel.rakuten.co.jp/';
const JRDP_LINK = env('UNIVERSAL_JRDP_UI_URL');
const JRDP_BREADCRUMB = 'https://travel.rakuten.co.jp/package/jr';

const paths = {
  top: {
    path: '/',
  },

  hotelTop: {
    pathResolver: (id: string, query?: URLSearchQuery, page?: string) =>
      `${HOTEL_TOP_LINK}/hinfo/${id}/${
        page ? `${page}/` : ''
      }?f_jrdp=1&f_jrdpquery=${encodeURIComponent(stringifyQueryParameter(query))}`,
  },
  hotelTopReview: {
    pathResolver: (id: string, query?: URLSearchQuery) =>
      `${HOTEL_TOP_REVIEW_LINK}/${id}?f_jrdp=1&f_jrdpquery=${encodeURIComponent(
        stringifyQueryParameter(query),
      )}`,
  },

  providerList: {
    path: `${basePaths.providerList}/:pageIdentifier(.*)?(/)?`,
    pathResolver: (pathId: string) => `${basePaths.providerList}/${pathId}/`,
  },

  providerListMap: {
    path: `${basePaths.providerListMap}/:pageIdentifier(.*)?(/)?`,
    pathResolver: (pathId: string) => `${basePaths.providerListMap}/${pathId}/`,
  },

  plansList: {
    path: `${basePaths.plansList}/:pageIdentifier(\\d+):pageNum([^/]*)?(/)?`,
    pathResolver: (pathId: string) => `${basePaths.plansList}/${pathId}/`,
  },

  planDetail: {
    path: `${basePaths.planDetail}/:providerId(\\d+)/:planId(\\d+)/:itemId(.*)?(/)?`,
    pathResolver: (providerId: string, planId: string, itemId?: string) => {
      const planItemId = itemId && itemId?.endsWith('/') ? `/${itemId}` : `/${itemId}/`;
      return `${basePaths.planDetail}/${providerId}/${planId}${itemId ? planItemId : '/'}`;
    },
  },
  notFound: {
    path: basePaths.notFound,
  },
  trainSearch: {
    path: `${JRDP_LINK}${basePaths.trainSearch}`,
  },
  itinerary: {
    path: `${JRDP_LINK}${basePaths.itinerary}`,
  },
  jrdp: {
    path: JRDP_BREADCRUMB,
  },
  rakutenTravelTopPage: {
    path: RAKUTEN_TRAVEL_TOP_LINK,
  },
};

export default paths;
